export const ACCOUNT_CASE_METRIC_SORT_COLUMNS = [
  "max_urgency",
  "treasury_churn_score",
] as const;

export type AccountCaseMetricSortColumn =
  (typeof ACCOUNT_CASE_METRIC_SORT_COLUMNS)[number];

export const ACCOUNT_CASE_METRICS = {
  treasuryChurn: {
    columnId: "treasuryChurn",
    stateKey: "treasuryChurn",
    rpcParam: "p_treasury_churn",
    urlKey: "tc",
    displayLabel: "Treasury Churn",
    chipLabel: "Has churn work item",
    badgeLabel: "Churn",
    activeCaseType: "churn_risk",
  },
  urgency: {
    columnId: "urgency",
    fieldId: "max_urgency",
    derivedField: "max_urgency",
    sortColumn: "max_urgency",
    displayLabel: "Urgency",
    minRpcParam: "p_urgency_min",
    maxRpcParam: "p_urgency_max",
  },
  treasuryChurnScore: {
    columnId: "treasuryChurnScore",
    fieldId: "treasury_churn_score",
    derivedField: "treasury_churn_score",
    sortColumn: "treasury_churn_score",
    displayLabel: "Churn Score",
    columnHeader: "Churn score",
    minRpcParam: "p_treasury_churn_score_min",
    maxRpcParam: "p_treasury_churn_score_max",
  },
} as const;

export function isAccountCaseMetricSortColumn(
  column: string | null | undefined,
): column is AccountCaseMetricSortColumn {
  return ACCOUNT_CASE_METRIC_SORT_COLUMNS.includes(
    column as AccountCaseMetricSortColumn,
  );
}
